export const pageTrackBlacklist = {
    integrations: {
        'Facebook Pixel': false,
    },
};

export const userSensitiveData = {
    integrations: {
        'Facebook Pixel': false,
    },
};

export const integrationsWithIdsInEvents = {
    'Facebook Pixel': true,
    'Google Tag Manager': true,
    'Google Ads (Classic)': true,
    'Google Analytics': true,
    HubSpot: false,
    Perspective: false,
};

export const integrationsWithOutIdsInEvents = {
    'Facebook Pixel': false,
    'Google Tag Manager': true,
    'Google Ads (Classic)': true,
    'Google Analytics': true,
    HubSpot: true,
    Perspective: true,
};

export const integrations = {
    adwords: 'adwords',
    facebookPixel: 'facebook-pixel',
    googleAnalytics: 'google-analytics',
    googleAnalytics4: 'google-analytics-4',
    googleTagManager: 'google-tag-manager',
    hubspot: 'hubspot',
    media: 'media',
    perspective: 'perspective',
    tiktok: 'tiktok',
    linkedin: 'linkedin',
    hotjar: 'hotjar',
};

export const integrationsToDisplayName = {
    [integrations.adwords]: 'Google Ads (Classic)',
    [integrations.facebookPixel]: 'Facebook Pixel',
    [integrations.googleAnalytics]: 'Google Analytics',
    [integrations.googleAnalytics4]: 'Google Analytics 4',
    [integrations.googleTagManager]: 'Google Tag Manager',
    [integrations.hubspot]: 'HubSpot',
    [integrations.media]: 'Media',
    [integrations.perspective]: 'Perspective',
    [integrations.tiktok]: 'TikTok',
    [integrations.linkedin]: 'LinkedIn Insight Tag',
    [integrations.hotjar]: 'Hotjar',
};

export const categoryMap = {
    marketing: [
        integrationsToDisplayName[integrations.adwords],
        integrationsToDisplayName[integrations.facebookPixel],
        integrationsToDisplayName[integrations.googleTagManager],
        integrationsToDisplayName[integrations.hubspot],
        integrationsToDisplayName[integrations.tiktok],
        integrationsToDisplayName[integrations.linkedin],
    ],
    analytics: [
        integrationsToDisplayName[integrations.googleAnalytics],
        integrationsToDisplayName[integrations.googleAnalytics4],
        integrationsToDisplayName[integrations.hotjar],
    ],
    media: [integrationsToDisplayName[integrations.media]],
    necessary: [integrationsToDisplayName[integrations.perspective]],
};

export const validScriptIntegrations = [
    integrationsToDisplayName[integrations.adwords],
    integrationsToDisplayName[integrations.facebookPixel],
    integrationsToDisplayName[integrations.googleAnalytics],
    integrationsToDisplayName[integrations.googleAnalytics4],
    integrationsToDisplayName[integrations.googleTagManager],
    integrationsToDisplayName[integrations.hubspot],
    integrationsToDisplayName[integrations.perspective],
    integrationsToDisplayName[integrations.tiktok],
    integrationsToDisplayName[integrations.linkedin],
    integrationsToDisplayName[integrations.hotjar],
];

export const activeIntegrations = {
    [integrations.adwords]: true,
    [integrations.facebookPixel]: true,
    [integrations.googleAnalytics]: true,
    [integrations.googleAnalytics4]: true,
    [integrations.googleTagManager]: true,
    [integrations.hubspot]: true,
    [integrations.perspective]: true,
    [integrations.tiktok]: true,
    [integrations.linkedin]: true,
    [integrations.hotjar]: true,
};
